import React from 'react';

export default function MapIcon({as = React.Fragment, Tag = as, ...props}) {
  return (
    <Tag {...props}>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" className="icon-map"><g><path className="secondary" d="M9 21a1 1 0 0 1-.45-.1l-6-3A1 1 0 0 1 2 17V4a1 1 0 0 1 1.45-.9L9 5.89V21zm6-18a1 1 0 0 1 .45.1l6 3A1 1 0 0 1 22 7v13a1 1 0 0 1-1.45.9L15 18.12V3z"/><path className="primary" d="M9 21V5.88l5.55-2.77A1 1 0 0 1 15 3v15.1L9.45 20.9A1 1 0 0 1 9 21z"/></g></svg>
    </Tag>
  )
};
